module.exports = __webpack_public_path__ + "static/media/093.71c87391.jpg";